import { ReturnTaskReadable } from '@crm/api'
import { TaskForm } from '@crm/components'
import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ModalProps } from 'antd/lib'

const formName = 'duplicate-task-form'

type Props = {
  task: ReturnTaskReadable | null
  onCancel: () => void
} & ModalProps

export const DuplicateTask = ({ task, onCancel, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      maskClosable={false}
      width={800}
      title={t('lead.task')}
      cancelText={t('buttons.cancel')}
      onCancel={onCancel}
      okText={t('buttons.save')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <TaskForm
        id={task?.id}
        duplicate
        formName={formName}
        onCancel={onCancel}
      />
    </Modal>
  )
}
